import styled from 'styled-components';
import { PageTab, PageTabsCont } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const CardsCont = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.decy} 0 0 0;
  `};
`;

export const CardButtonsCont = styled(PageTabsCont)`
  flex: 1;
`;

export const CardNavButton = styled(PageTab)``;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  height: 32px;
  padding: 0 12px 0 8px;
  border: none;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
    color: ${theme.colors.secondary[100]};
    box-shadow: 0 1px 2px rgba(24, 58, 96, 0.08);

    &:hover {
      background: ${theme.colors.primary[10]};
    }
  `}
`;

export const ArrowCont = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  justify-content: center;
  align-items: center;
  transform: rotate(180deg);
  svg {
    height: 10px;
  }
  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.nano} 0 0;
  `}
`;
